import script from "./AdminStatisticPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminStatisticPage.vue?vue&type=script&lang=ts&setup=true"

import "./AdminStatisticPage.vue?vue&type=style&index=0&id=28d9bddd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d9bddd"]])

export default __exports__